package com.devi3east.bashbuddy.prizeList.ui.components

import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.LocalIndication
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.combinedClickable
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Card
import androidx.compose.material3.CardDefaults
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import com.devi3east.bashbuddy.features.common.util.DateTimeFormatUtil
import kotlinx.datetime.Instant

@Composable
fun PrizeCard(
    icon: @Composable () -> Unit,
    timeSlot: Instant? = null,
    serialNumber: String? = null,
    prize: String? = null,
    winningNumber: String? = null,
    winningNumberVisible: Boolean = true,
    onLongClick: (() -> Unit)? = null,
    onClickCard: (() -> Unit)? = null
) {
    val timeSlotFormatted = remember(timeSlot) {
        DateTimeFormatUtil.instantToTimeString(timeSlot)
    }

    val winningNumberShape = RoundedCornerShape(12.dp)
    val interactionSource = remember { MutableInteractionSource() }

    Card(
        modifier = Modifier
            .fillMaxWidth()
            .padding(vertical = 6.dp)
            .clip(RoundedCornerShape(16.dp))
            .combinedClickable(
                onClick = { onClickCard?.invoke() }, // single click opens update
                onLongClick = { onLongClick?.invoke() }, // long click for delete
                indication = LocalIndication.current,
                interactionSource = interactionSource
            ),
        shape = RoundedCornerShape(16.dp),
        elevation = CardDefaults.cardElevation(defaultElevation = 3.dp),
        border = BorderStroke(1.dp, MaterialTheme.colorScheme.outlineVariant),
        colors = CardDefaults.cardColors(containerColor = MaterialTheme.colorScheme.surface)
    ) {
        Row(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 16.dp, vertical = 12.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(12.dp)
        ) {
            // --- Icon ---
            Box(
                modifier = Modifier.widthIn(min = 32.dp),
                contentAlignment = Alignment.Center
            ) {
                icon()
            }

            // --- Info column ---
            Column(
                modifier = Modifier
                    .weight(1f)
                    .padding(end = 8.dp),
                verticalArrangement = Arrangement.spacedBy(2.dp)
            ) {
                val subLabel = timeSlotFormatted.ifEmpty { serialNumber ?: "" }
                if (subLabel.isNotEmpty()) {
                    Text(
                        text = subLabel,
                        style = MaterialTheme.typography.bodySmall,
                        color = MaterialTheme.colorScheme.onSurfaceVariant
                    )
                }

                Text(
                    text = prize ?: "Unknown Prize",
                    style = MaterialTheme.typography.bodyLarge.copy(fontWeight = FontWeight.Medium),
                    color = MaterialTheme.colorScheme.onSurface
                )
            }

            // --- Winning number box (no click) ---
            if (winningNumberVisible) {
                Box(
                    modifier = Modifier
                        .clip(winningNumberShape)
                        .background(MaterialTheme.colorScheme.surfaceContainerHigh)
                        .border(1.dp, MaterialTheme.colorScheme.outlineVariant, winningNumberShape)
                        .padding(horizontal = 12.dp, vertical = 12.dp)
                        .widthIn(min = 54.dp),
                    contentAlignment = Alignment.Center
                ) {
                    Text(
                        text = winningNumber ?: "",
                        style = MaterialTheme.typography.bodyMedium.copy(fontWeight = FontWeight.Medium),
                        color = if (winningNumber != null)
                            MaterialTheme.colorScheme.onSurface
                        else
                            MaterialTheme.colorScheme.onSurface.copy(alpha = 0.3f)
                    )
                }
            }
        }
    }
}